import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["badgeFromUrlType", "mto", "badgeFromUrlHeight", "color", "backgroundColor", "borderColor", "flyout", "flyoutColor", "counter", "children", "className", "data-test"];
import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sainsburys-tech/bolt';
import StyledBadge from './Badge.styles';
import MtoBadge from './MTOBadge.styles';

var Badge = function Badge(_ref) {
  var badgeFromUrlType = _ref.badgeFromUrlType,
      mto = _ref.mto,
      badgeFromUrlHeight = _ref.badgeFromUrlHeight,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      flyout = _ref.flyout,
      flyoutColor = _ref.flyoutColor,
      counter = _ref.counter,
      children = _ref.children,
      className = _ref.className,
      dataTest = _ref['data-test'],
      props = _objectWithoutProperties(_ref, _excluded);

  if (badgeFromUrlType) {
    // badgeFromUrlType seems to have an underscore in all cases. The regex below replaces this with a space for better accessibility
    var imageAlt = badgeFromUrlType.replace(/_/g, ' ');
    return /*#__PURE__*/React.createElement(Image, {
      src: "https://media.4rgos.it/i/Argos/".concat(badgeFromUrlType),
      alt: imageAlt,
      height: badgeFromUrlHeight,
      quality: 90,
      className: className,
      "data-test": "".concat(dataTest, "-image")
    });
  }

  if (mto) {
    return /*#__PURE__*/React.createElement(MtoBadge, {
      className: className
    }, "Made to order");
  }

  if (children) {
    return /*#__PURE__*/React.createElement(StyledBadge, _extends({
      color: color,
      backgroundColor: backgroundColor,
      borderColor: borderColor,
      className: className,
      "data-test": dataTest,
      flyout: flyout,
      flyoutColor: flyoutColor,
      counter: counter
    }, props), children);
  }

  return '';
};

Badge.displayName = 'Badge';
Badge.propTypes = {
  /**
   * Specify the content of your Badge
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be added to your Button
   */
  className: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added to your Button for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Prop to render the badge type from an URL
   */
  badgeFromUrlType: PropTypes.string,

  /**
   * Prop to render the MTO badge type
   */
  mto: PropTypes.bool,

  /**
   * Prop to specifiy the height of the badge rendered from an URL
   */
  badgeFromUrlHeight: PropTypes.string,

  /**
   * Prop to specifiy the badge text color
   */
  color: PropTypes.string,

  /**
   * Prop to specifiy the badge background color
   */
  backgroundColor: PropTypes.string,

  /**
   * Prop to specifiy the counter variant border color
   */
  borderColor: PropTypes.string,

  /**
   * Prop to specify whether or not badge has a flyout visual effect
   */
  flyout: PropTypes.bool,

  /**
   * Prop to specifiy the badge flyout color
   */
  flyoutColor: PropTypes.string,

  /**
   * Prop to specify whether or not badge is a counter
   */
  counter: PropTypes.bool
};
Badge.defaultProps = {
  badgeFromUrlHeight: '24',
  flyout: false,
  flyoutColor: '#333',
  // grey darker
  'data-test': 'component-badge'
};
export default Badge;